// this.$ga.event('category', 'action', 'label', 123)

export const disclaimer = {
  accept: [
    'Disclaimer Acceptance',
    'Accept',
    null,
    1,
  ],
  
  decline: [
    'Disclaimer Acceptance',
    'Decline',
    null,
    1,
  ],
}


export const ETResearchReport = {
  headlineClick: [
    'ET Research Report',
    'Dashboard Headline Click',
    null,
    1
  ],
  reportRead: [
    'ET Research Report',
    'Read Report',
    null,
    1
  ]
}
